module.exports = __webpack_public_path__ + "static/img/news4_img.5381022.png";